import * as S from './styles'

const Footer = () => {
  return (
    <S.FooterContainer>
      <S.FooterText>
        Developed by
        <a href="https://www.linkedin.com/in/hsanfilippo/"> hsanfilippo</a> (
        <a href="https://github.com/hsanfilippo">GitHub</a> -
        <a href="https://www.linkedin.com/in/hsanfilippo/"> LinkedIn </a> -
        <a href="https://wa.me/+5511943956929"> WhatsApp</a>) - 2025
      </S.FooterText>
    </S.FooterContainer>
  )
}

export default Footer
